export enum DriverLicesnseStatus {
  NotCheckedYet = 0,
  Valid = 1,
  Invalid = 2,
  DocumentNotFound = 3,
  InsufficientData = 4,
  UnknownError = 5
}
